module.exports = __webpack_public_path__ + "img/Group 10.0c88ff68.svg";